/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DrmOperationInterval } from './DrmOperationInterval';
import {
    DrmOperationIntervalFromJSON,
    DrmOperationIntervalFromJSONTyped,
    DrmOperationIntervalToJSON,
} from './DrmOperationInterval';

/**
 * 
 * @export
 * @interface TfOrientationDrmOperationInterval
 */
export interface TfOrientationDrmOperationInterval extends DrmOperationInterval {
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    tfSetpoint: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    spring: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    pressureMax: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    differentialPressure: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    tight: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    slackingOff: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    torqueMax: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    repetitionsCount: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    ropUp: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    ropDown: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    flowRateUp: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    flowRateDown: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    interval: number;
    /**
     * 
     * @type {number}
     * @memberof TfOrientationDrmOperationInterval
     */
    stopPointOffBottom: number;
}

/**
 * Check if a given object implements the TfOrientationDrmOperationInterval interface.
 */
export function instanceOfTfOrientationDrmOperationInterval(value: object): value is TfOrientationDrmOperationInterval {
    if (!('tfSetpoint' in value) || value['tfSetpoint'] === undefined) return false;
    if (!('spring' in value) || value['spring'] === undefined) return false;
    if (!('pressureMax' in value) || value['pressureMax'] === undefined) return false;
    if (!('differentialPressure' in value) || value['differentialPressure'] === undefined) return false;
    if (!('tight' in value) || value['tight'] === undefined) return false;
    if (!('slackingOff' in value) || value['slackingOff'] === undefined) return false;
    if (!('torqueMax' in value) || value['torqueMax'] === undefined) return false;
    if (!('repetitionsCount' in value) || value['repetitionsCount'] === undefined) return false;
    if (!('ropUp' in value) || value['ropUp'] === undefined) return false;
    if (!('ropDown' in value) || value['ropDown'] === undefined) return false;
    if (!('flowRateUp' in value) || value['flowRateUp'] === undefined) return false;
    if (!('flowRateDown' in value) || value['flowRateDown'] === undefined) return false;
    if (!('interval' in value) || value['interval'] === undefined) return false;
    if (!('stopPointOffBottom' in value) || value['stopPointOffBottom'] === undefined) return false;
    return true;
}

export function TfOrientationDrmOperationIntervalFromJSON(json: any): TfOrientationDrmOperationInterval {
    return TfOrientationDrmOperationIntervalFromJSONTyped(json, false);
}

export function TfOrientationDrmOperationIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): TfOrientationDrmOperationInterval {
    if (json == null) {
        return json;
    }
    return {
        ...DrmOperationIntervalFromJSONTyped(json, ignoreDiscriminator),
        'tfSetpoint': json['tfSetpoint'],
        'spring': json['spring'],
        'pressureMax': json['pressureMax'],
        'differentialPressure': json['differentialPressure'],
        'tight': json['tight'],
        'slackingOff': json['slackingOff'],
        'torqueMax': json['torqueMax'],
        'repetitionsCount': json['repetitionsCount'],
        'ropUp': json['ropUp'],
        'ropDown': json['ropDown'],
        'flowRateUp': json['flowRateUp'],
        'flowRateDown': json['flowRateDown'],
        'interval': json['interval'],
        'stopPointOffBottom': json['stopPointOffBottom'],
    };
}

export function TfOrientationDrmOperationIntervalToJSON(value?: TfOrientationDrmOperationInterval | null): any {
    if (value == null) {
        return value;
    }
    return {
        ...DrmOperationIntervalToJSON(value),
        'tfSetpoint': value['tfSetpoint'],
        'spring': value['spring'],
        'pressureMax': value['pressureMax'],
        'differentialPressure': value['differentialPressure'],
        'tight': value['tight'],
        'slackingOff': value['slackingOff'],
        'torqueMax': value['torqueMax'],
        'repetitionsCount': value['repetitionsCount'],
        'ropUp': value['ropUp'],
        'ropDown': value['ropDown'],
        'flowRateUp': value['flowRateUp'],
        'flowRateDown': value['flowRateDown'],
        'interval': value['interval'],
        'stopPointOffBottom': value['stopPointOffBottom'],
    };
}

